<template>
  <div :class="{ 'page-class': !$store.getters.tableConfig.card }">
    <avue-crud
      :data="tableData"
      :option="tbleOption"
      @row-save="handleSubmit"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @on-load="onLoad"
      @refresh-change="getList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      :page.sync="page"
    >
      <template slot="menuLeft">
        <el-button type="primary" v-has="[dataApi.getList]" size="small">测试{{dataApi.getList.p}}</el-button>
        <el-button type="primary" size="small">测试{{$_has([dataApi.getList])}}</el-button>
      </template>
    </avue-crud>
  </div>
</template>
<script>
import List from './list';

export default List;
</script>
